import { nextTick } from 'vue';
import { store } from '../../../../../resources/frontend/js/store';
import getQuestion from './get-question';
import { updateParameter, updateParameters } from '../history';
import { checkWorkTypeOverride } from '../worktype-override';
import dataLayerPush from '../../utils/data-layer-push';
import scrollToSelector from '../../utils/scroll-to-selector';

export const goToQuestion = (preHook, questionId, afterHook) => {
    const storeQuiz = store.state.quiz;
    const storePage = store.state.page;
    const question = getQuestion(questionId);
    const previousQuestion = getQuestion(storeQuiz.currentQuestion);
    const previousQuestionStep = store.getters['page/getStepFromString'](previousQuestion.step);

    typeof preHook === 'function' && preHook();

    if (!questionId) {
        storeQuiz.questionCount = storeQuiz.totalFlowLength + 1;

        setTimeout(() => {
            storeQuiz.currentQuestion++;
            store.commit('page/setStep', previousQuestionStep + 1);
            updateParameter('data_step', storePage.step);
            checkWorkTypeOverride();
        }, 500);
        return;
    }

    const isContinuousFlow = storeQuiz.continuousFlow;
    const questionNumber = storeQuiz.questionsData.indexOf(question) + 1;
    const questionType = questionNumber > storeQuiz.currentQuestion ? 'next' : 'previous';
    let nextStep = questionType === 'next' ? storePage.step + 1 : storePage.step - 1;

    if (isContinuousFlow || storePage.step === storePage.steps.length) {
        nextStep = storePage.steps.length;
    }

    if (storePage.steps.length === 1) {
        nextStep = 1
    }

    const nextStepObject = storePage.data[storePage.steps[nextStep - 1].key];
    const nextQuestionStep = store.getters['page/getStepFromString'](question.step);

    if (nextQuestionStep !== store.state.page.step) {
        if (nextStep === nextQuestionStep || nextStepObject._info['step-data']?.type === 'quiz') {
            store.commit('page/setStep', nextQuestionStep);
        } else {
            store.commit('page/setStep', nextStep);
        }

        if (storePage.step !== 1 && storePage.autoScroll) {
            scrollToSelector('body');
        }
    }

    storeQuiz.currentQuestion = questionNumber;
    dataLayerPush(`Question ${storeQuiz.currentQuestion}`);

    if (questionType === 'next') {
        storeQuiz.questionCount++;
        storeQuiz.questionFlow.push(storeQuiz.currentQuestion);

        store.commit('page/increasePixelStep', { label: 'Question' });

        updateParameters({
            data_question: storeQuiz.currentQuestion,
            data_step: storePage.step,
        });
    } else if (questionType === 'previous') {
        storeQuiz.questionCount--;
        storeQuiz.questionFlow.pop();

        typeof afterHook === 'function' && afterHook();

        store.commit('page/decreasePixelStep', { label: 'Question' });
    }

    if (!store.state.page.isPreview) {
        nextTick(() => {
            store.commit('cro/runQuestionChangeEvents', storeQuiz.currentQuestion);
        });
    }
};
